const debug = (
  typeof process === 'object' &&
  process.env &&
  process.env.NODE_DEBUG &&
  /\bsemver\b/i.test(process.env.NODE_DEBUG)
) ? (...args) => console.error('SEMVER', ...args)
  : () => {}

module.exports = debug



//////////////////
// WEBPACK FOOTER
// ./~/semver/internal/debug.js
// module id = 259
// module chunks = 0